import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

export const getDataJobAll = async (body) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/job`, {
            headers: headers
        });
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error.response.data.message,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};
function blobToFile(blob, fileName) {
    // Create a new File object, using the blob as its data, and set the fileName
    const file = new File([blob], fileName);
    return file;
}
export const createAndUpdateJob = async (body) => {
    try {
        const formData = new FormData()
        formData.append('corevalue_en', body.corevalue_en)
        formData.append('corevalue_th', body.corevalue_th)
        formData.append('welfare_en', body.welfare_en)
        formData.append('welfare_th', body.welfare_th)
        formData.append('welfare_list', JSON.stringify(body.welfare_list))
        formData.append('welfare_title_th', body.welfare_title_th)
        if (body.image_creatively.length > 0) {
            if(body.image_creatively[0].file?.file){
                const blob = new Blob([body.image_creatively[0].file?.file], { type: body.image_creatively[0].file?.file.type });
                const parts = body.image_creatively[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/png",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.image_creatively[0].file.size
                  });

                formData.append('image_creatively', file)
            }
            else{
                formData.append('image_creatively', body.image_creatively[0].file)
            }
        }
        else{
            formData.append('image_creatively', null)
        }

        if (body.image_responsively.length > 0) {
            if(body.image_responsively[0].file?.file){
                const blob = new Blob([body.image_responsively[0].file?.file], { type: body.image_responsively[0].file?.file.type });
                const parts = body.image_responsively[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/png",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.image_responsively[0].file.size
                  });

                formData.append('image_responsively', file)
            }
            else{
                formData.append('image_responsively', body.image_responsively[0].file)
            }
        }
        else{
            formData.append('image_responsively', null)
        }

        if (body.image_passionately.length > 0) {
            if(body.image_passionately[0].file?.file){
                const blob = new Blob([body.image_passionately[0].file?.file], { type: body.image_passionately[0].file?.file.type });
                const parts = body.image_passionately[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/png",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.image_passionately[0].file.size
                  });

                formData.append('image_passionately', file)
            }
            else{
                formData.append('image_passionately', body.image_passionately[0].file)
            }
        }
        else{
            formData.append('image_passionately', null)
        }

        if (body.image_accountably.length > 0) {
            if(body.image_accountably[0].file?.file){
                const blob = new Blob([body.image_accountably[0].file?.file], { type: body.image_accountably[0].file?.file.type });
                const parts = body.image_accountably[0].file?.src.split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: "image/png",
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.image_accountably[0].file.size
                  });

                formData.append('image_accountably', file)
            }
            else{
                formData.append('image_accountably', body.image_accountably[0].file)
            }
        }
        else{
            formData.append('image_accountably', null)
        }

        const rs = await instance.post(`/api/mgr/job`, formData, {
            headers: {
                Authorization: `Bearer ` + dataToken,
            },
        });

        if (rs.data.status === "success") {
            return rs.data;
        } else {
            return null;
        }

        // return true
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error.response.data.message,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};